// extracted by mini-css-extract-plugin
export default {"tooltip":"LateStageLabel_tooltip__ElunF"};